import CarouselSliderFachada from "./CarouselSliderFachada";

export default CarouselSliderFachada;
